"use client";
import H from "../../hooks/useHandleStateClick.js";
import { cn as M } from "../../utils/cn.js";
import { dataBooleanAttr as B } from "../../utils/dataBooleanAttr.js";
import { setComponentColor as j } from "../../utils/setComponentColor.js";
import { colorVariants as q } from "../../vars/variants.js";
import C from "next/link";
import { useMemo as D, useCallback as F, isValidElement as J, cloneElement as K } from "react";
import { useButtonGroupContext as Q } from "./button-group-context.js";
import { stylesButton as s } from "./styles.js";
function ne(u) {
  const e = Q(), d = !!e, {
    ref: m,
    as: w,
    href: i,
    children: G,
    startContent: O,
    endContent: S,
    className: f,
    spinner: T,
    loading: n = !1,
    disableRipple: U = !1,
    wide: b = (e == null ? void 0 : e.wide) ?? !1,
    centerContent: p = (e == null ? void 0 : e.centerContent) ?? !1,
    centerText: l = (e == null ? void 0 : e.centerText) ?? !1,
    radius: r = e == null ? void 0 : e.radius,
    size: I = (e == null ? void 0 : e.size) ?? "lg",
    spinnerSize: v = (e == null ? void 0 : e.spinnerSize) ?? "sm",
    color: t = (e == null ? void 0 : e.color) ?? "regular",
    variant: k = (e == null ? void 0 : e.variant) ?? "solid",
    disabled: a = (e == null ? void 0 : e.disabled) ?? !1,
    isIconOnly: o = (e == null ? void 0 : e.isIconOnly) ?? !1,
    spinnerPlacement: E = "start",
    onClick: L,
    scroll: W = !0,
    ...P
  } = u, h = H(L, n, a), N = w || (i ? C : "button"), y = D(
    () => M(
      // setComponentColor(color),
      s.base,
      s.size[I],
      q[k][t],
      r && s.radius[r],
      b && s.wide,
      p && s.centerContent,
      l && s.centerText,
      d && s.isInGroup,
      o && s.isIconOnly,
      f
    ),
    [
      I,
      k,
      t,
      r,
      b,
      p,
      l,
      d,
      o,
      f
    ]
  ), R = F(
    (c = {}) => ({
      "data-loading": B(n),
      "data-disabled": B(a),
      // "data-hover": dataBooleanAttr(isHovered),
      ...P,
      ref: m,
      href: i,
      className: y,
      style: j(t),
      onClick: h,
      disabled: a || n
    }),
    [n, a, P, m, i, y, t, h]
  ), z = (c) => J(c) ? K(c, {
    // @ts-ignore
    "aria-hidden": !0,
    focusable: !1,
    tabIndex: -1
  }) : null, V = z(O), A = z(S);
  return {
    Component: N,
    children: G,
    spinner: T,
    startContent: V,
    endContent: A,
    loading: n,
    spinnerPlacement: E,
    spinnerSize: v,
    getButtonProps: R,
    isIconOnly: o,
    centerText: l
  };
}
export {
  ne as useButton
};
